import { useEffect, useState } from "react"
import { Dimensions } from "react-native"

function getNumColsFromWidth(width: number, colWidth: number) {
  return Math.max(Math.floor(width / colWidth), 1)
}

export function useNumCols(colWidth = 200, options?: { maxWidth: number }) {
  const MAX_WIDTH = options?.maxWidth ?? 1200

  const [numCols, setNumCols] = useState(() => {
    const window = Dimensions.get("window")
    return getNumColsFromWidth(Math.min(window.width, MAX_WIDTH), colWidth)
  })

  useEffect(() => {
    const listener = Dimensions.addEventListener("change", ({ window }) => {
      setNumCols(getNumColsFromWidth(Math.min(window.width, MAX_WIDTH), colWidth))
    })

    return () => {
      listener.remove()
    }
  }, [colWidth, options?.maxWidth])

  return numCols
}
